<nav
  *ngIf="version !== 3"
  class="cmx-navbar cmx-navbar--v2"
  [ngClass]="{
    'cmx-navbar--collapsed': !isMobile && isCollapsed,
    'cmx-navbar--mobile': isMobile,
    'cmx-navbar--rtl': isRtl,
    'cmx-navbar--submenu-open': (menu.menuItemSelectedId | async) !== -1
  }"
>
  <div
    *ngIf="!isMobile"
    (click)="toggleCollapse()"
    class="cmx-navbar__trigger"
    [ngClass]="{
      'cmx-navbar__trigger--rtl': isRtl,
      'cmx-navbar__trigger--hidden': isLegalEntityListOpen
    }"
    [attr.data-tid]="'sidebar-toggle'"
  >
    <span
      *ngIf="!isRtl"
      class="cmx-icon-left-double cmx-navbar__trigger-icon"
      [ngClass]="{ 'cmx-navbar__trigger-icon--collapsed': !isMobile && isCollapsed }"
    ></span>
    <span
      *ngIf="isRtl"
      class="cmx-icon-right-double cmx-navbar__trigger-icon"
      [ngClass]="{ 'cmx-navbar__trigger-icon--collapsed': !isMobile && isCollapsed }"
    ></span>
  </div>
  <div *ngIf="isMobile" class="cmx-navbar__mobile-menu">
    <!-- Mobile User -->
    <div
      class="cmx-navbar__mobile-menu-item"
      (click)="mobileUserClick()"
      [ngClass]="{ 'cmx-navbar__mobile-menu-item--rtl': isRtl }"
    >
      <div class="cmx-navbar__mobile-menu-item-icon">
        <div class="cmx-icon cmx-icon--inverted">{{ layout.userInitials | async }}</div>
      </div>
      <div class="cmx-navbar__mobile-menu-item-label">
        {{ layout.userName | async }}
      </div>
    </div>
    <!-- Mobile Apps Menu -->
    <div
      *ngIf="layout.appMenu | async"
      class="cmx-navbar__mobile-menu-item"
      (click)="mobileAppMenuClick()"
      [ngClass]="{ 'cmx-navbar__mobile-menu-item--rtl': isRtl }"
    >
      <div class="cmx-navbar__mobile-menu-item-icon">
        <div class="cmx-icon-modules-internal-consoles"></div>
      </div>
      <div class="cmx-navbar__mobile-menu-item-label">
        {{ layout.appMenuLabel | async }}
      </div>
    </div>
  </div>
  <cmx-legal-entity *ngIf="legalEntity.legalEntity | async" style="z-index: 10"></cmx-legal-entity>
  <cmx-legal-entity-listing
    *ngIf="!isMobile && (legalEntity.legalEntity | async)"
    class="cmx-navbar__legal-entity-listing"
    [ngClass]="{ 'cmx-navbar__legal-entity-listing--closed': !isLegalEntityListOpen }"
  >
  </cmx-legal-entity-listing>
  <div class="cmx-navbar__spacer" *ngIf="!isMobile && !(legalEntity.legalEntity | async)"></div>
  <cmx-nav-menu class="scrollbar cmx-navbar__nav-menu"></cmx-nav-menu>
  <hr *ngIf="isMobile" class="cmx-navbar__separator" />
  <div *ngIf="isMobile && (layout.language | async)" (click)="mobileLangClick()" class="cmx-navbar__mobile-menu">
    <div class="cmx-navbar__mobile-menu-item" [ngClass]="{ 'cmx-navbar__mobile-menu-item--rtl': isRtl }">
      <div class="cmx-navbar__mobile-menu-item-icon">
        <div class="cmx-icon-language"></div>
      </div>
      <div class="cmx-navbar__mobile-menu-item-label">
        {{ layout.languageLabel | async }}
      </div>
    </div>
  </div>
  <ng-container *ngIf="isMobile">
    <div
      *ngFor="let link of layout.mobileLinks | async"
      (click)="mobileLinkClick(link.id)"
      class="cmx-navbar__mobile-menu"
    >
      <div class="cmx-navbar__mobile-menu-item" [ngClass]="{ 'cmx-navbar__mobile-menu-item--rtl': isRtl }">
        <div class="cmx-navbar__mobile-menu-item-icon">
          <div [ngClass]="link.icon"></div>
        </div>
        <div class="cmx-navbar__mobile-menu-item-label">
          {{ link.label }}
        </div>
      </div>
    </div>
  </ng-container>
  <div *ngIf="isMobile" (click)="mobileLogutClick()" class="cmx-navbar__mobile-menu">
    <div class="cmx-navbar__mobile-menu-item" [ngClass]="{ 'cmx-navbar__mobile-menu-item--rtl': isRtl }">
      <div class="cmx-navbar__mobile-menu-item-icon">
        <div class="cmx-icon-logout"></div>
      </div>
      <div class="cmx-navbar__mobile-menu-item-label">
        {{ buttons.logoutLabel | async }}
      </div>
    </div>
  </div>
  <hr *ngIf="isMobile" class="cmx-navbar__separator" />
  <div *ngIf="isMobile" class="cmx-navbar__text" [innerHtml]="layout.footerLabel | async"></div>
</nav>
<cwc-sidenav
  slot="sidenav"
  *ngIf="version === 3"
  class="variant cmx-nav-3"
  [ngClass]="{ 'cmx-sidebar__modal-open': isModalOpen }"
  [dir]="isRtl ? 'rtl' : 'ltr'"
  [variant]="variant"
  [enableEventListenerToggle]="true"
  (collapsed)="isSidenavOpen($event)"
>
  <cmx-legal-entity-listing
    id="entitySelector"
    slot="legal-entity-selection"
    [entityName]="entityName"
    [entityId]="entityId"
    [employeeVariant]="employeeVariant"
  ></cmx-legal-entity-listing>
  <cwc-sidenav-menu
    slot="menu-items"
    [dir]="isRtl ? 'rtl' : 'ltr'"
    [variant]="variant"
    (cwcRendered)="sideNavMenuRendered($event)"
  >
    <cmx-nav-menu id="menuNav"></cmx-nav-menu>
  </cwc-sidenav-menu>
  <!-- Footer Menu -->
  <cwc-footer-menu
    slot="links"
    class="variant"
    [variant]="variant ? variant : userCountry == 'IL' ? 'negative' : 'positive'"
    class="collapsable 'sidenav__footer__width__open'"
  >
    <cwc-footer-menu-item
      *ngFor="let link of layout.footerLinks | async"
      (click)="layout.footerLinkClick.emit(link.id)"
      [label]="link.label"
      [variant]="variant ? variant : userCountry == 'IL' ? 'negative' : 'positive'"
    >
    </cwc-footer-menu-item>
  </cwc-footer-menu>
  <div
    slot="copyright"
    (click)="layout.footerLabelClick.emit()"
    [innerHtml]="footerLabel"
    class="collapsable"
    [class]="!isMobile && isCollapsed ? 'sidenav__footer__width__collapsed' : 'sidenav__footer__width__open'"
  ></div>
</cwc-sidenav>
